import {
	Component,
	HostBinding,
	OnInit,
	ChangeDetectorRef,
	Input,
	Inject, AfterViewInit
} from '@angular/core';

import { userAgentUtil } from '../../UserAgentUtil';

import { VideogularComponent } from '../Videogular.Component';

import { PLAYER_USER_PREFERENCE_KEY } from '../../shared/userPreference/PlayerUserPreferenceHandler';
import { PlayerUserPreferencesService } from '../../shared/userPreference/PlayerUserPreference.Service';
import { VBRICK_PLAYER_HOST } from '../../VbPlayerHostToken';
import { VG_VOLUME_COMPONENT_TOKEN } from './VgVolumeComponentToken';

const CHANGE_PER_PRESS = 0.05;

@Component({
	selector: 'vg-volume',
	providers: [
		{
			provide: VG_VOLUME_COMPONENT_TOKEN,
			useExisting: VgVolumeComponent
		}
	],
	host: {
		'[class.controlRoot]': 'true',
		'[class.smallSizePlayer]': 'isSmallSizePlayer'
	},
	template: `
		<vg-mute-button
			[currentVolume]="vgApi.volume"
			[vbrickPlayer]="vbrickPlayer">
		</vg-mute-button>

		<vg-volume-bar *vgControlDisplay="4"
			[translations]="translations"
			[isSmallSizePlayer]="isSmallSizePlayer">
		</vg-volume-bar>
	`,
	standalone: false,
	styleUrls: ['./VgVolume.Component.ng.less']
})
export class VgVolumeComponent implements OnInit, AfterViewInit {
	@Input() public translations: any;
	@Input() public isSmallSizePlayer: boolean;

	public isVolumeBarVisible: boolean;
	private mouseLeaveTimeoutRef: number;
	private _isEntered: boolean;

	constructor(
		public changeDetector: ChangeDetectorRef,
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any,
		public vgApi: VideogularComponent,
		private readonly PlayerUserPreferencesService: PlayerUserPreferencesService
	) { }

	public ngOnInit(): void {
		this.updateElementVisibilityClass(false);
	}

	public ngAfterViewInit(): void {
		const userPreferenceVolume = this.PlayerUserPreferencesService.getPreference<number>(PLAYER_USER_PREFERENCE_KEY.VOLUME);
		if (userPreferenceVolume != null) {
			this.vgApi.setVolume(userPreferenceVolume);
		}
	}

	public get isEntered(): boolean {
		return this._isEntered;
	}

	public updateElementVisibilityClass(isVisible: boolean): void {
		this.isVolumeBarVisible = isVisible;

		this.changeDetector.detectChanges();
	}

	@HostBinding('hidden')
	private get isComponentSurfaced(): boolean {
		return userAgentUtil.isMobile || userAgentUtil.isAndroidChrome;
	}

	public onVolumeAreaKeyDown(event: KeyboardEvent): void {
		const isUp = event.key === 'ArrowUp' || event.key === 'ArrowRight';
		const isDown = event.key === 'ArrowDown' || event.key === 'ArrowLeft';
		if (!isUp && !isDown) {
			return;
		}

		const currentVolume = this.vgApi.volume != null ?
			this.vgApi.volume :
			1;
		const newVolume = isUp ? Math.min(1, currentVolume + CHANGE_PER_PRESS)
			: Math.max(0, currentVolume - CHANGE_PER_PRESS);

		this.vgApi.setVolume(newVolume);
		this.storeVolumePreference();
		event.preventDefault();
	}

	public storeVolumePreference(): void {
		this.PlayerUserPreferencesService.setPreference<number>(PLAYER_USER_PREFERENCE_KEY.VOLUME, this.vgApi.volume);
	}
}
